import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sl-reports-library',
  template: `
    <p>
      sl-reports-library works!
    </p>
  `,
  styles: [
  ]
})
export class SlReportsLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
